/* import __COLOCATED_TEMPLATE__ from './sdr-followup-email.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import templateOnlyComponent from '@ember/component/template-only';
import type SdrFollowupEmail from 'embercom/models/operator/visual-builder/step/sdr-followup-email';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import { type ComponentLike } from '@glint/template';
import type ConnectionPoint from 'embercom/models/operator/visual-builder/connection-point';

interface Signature {
  Args: {
    step: SdrFollowupEmail;
    stepConfig?: Record<string, unknown>;
    editorState: EditorState;
    updateConnectionPoints: () => void;
    connectionPointComponent: ComponentLike<{ connectionPoint: ConnectionPoint }>;
    readOnly: boolean;
  };
}

const SdrFollowupEmailComponent = templateOnlyComponent<Signature>();
export default SdrFollowupEmailComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::SdrFollowupEmail': typeof SdrFollowupEmailComponent;
  }
}
